import type { Navigation } from "zudoku";

export const navigation: Navigation = [
  {
    type: "category",
    label: "Getting Started",
    link: {
      type: "doc",
      file: "getting-started/introduction",
    },
    items: [
      { type: "doc", file: "getting-started/introduction", label: "Introduction" },
      { type: "doc", file: "getting-started/sign-in", label: "Sign in" },
      { type: "doc", file: "getting-started/navigation", label: "Navigation" },
    ],
  },
  {
    type: "category",
    label: "Account",
    link: {
      type: "doc",
      file: "account/organization",
    },
    items: [
      { type: "doc", file: "account/organization", label: "Organization" },
      { type: "doc", file: "account/dashboard", label: "Dashboard" },
    ],
  },
  {
    type: "category",
    label: "Billing",
    link: {
      type: "doc",
      file: "billing/overview",
    },
    items: [
      { type: "doc", file: "billing/overview", label: "Overview" },
      { type: "doc", file: "billing/invoices", label: "Invoices" },
      { type: "doc", file: "billing/invoice-detail", label: "Invoice detail" },
      { type: "doc", file: "billing/invoice-pay", label: "Pay invoice" },
      { type: "doc", file: "billing/wallet", label: "Wallet" },
      { type: "doc", file: "billing/transaction-detail", label: "Transaction detail" },
      { type: "doc", file: "billing/top-up", label: "Top up" },
      { type: "doc", file: "billing/payment-methods", label: "Payment methods" },
      { type: "doc", file: "billing/auto-top-up", label: "Auto top-up" },
      { type: "doc", file: "billing/notifications", label: "Notifications" },
    ],
  },
  {
    type: "category",
    label: "Support",
    link: {
      type: "doc",
      file: "support/tickets",
    },
    items: [
      { type: "doc", file: "support/tickets", label: "Tickets" },
      { type: "doc", file: "support/create-ticket", label: "Create a ticket" },
    ],
  },
  {
    type: "category",
    label: "Data",
    link: {
      type: "doc",
      file: "data/whitelabel/overview",
    },
    items: [
      {
        type: "category",
        label: "Whitelabel",
        link: {
          type: "doc",
          file: "data/whitelabel/overview",
        },
        items: [
          { type: "doc", file: "data/whitelabel/overview", label: "Overview" },
          { type: "doc", file: "data/whitelabel/dashboard", label: "Dashboard" },
          { type: "doc", file: "data/whitelabel/reports", label: "Reports" },
          { type: "doc", file: "data/whitelabel/links", label: "Links" },
          { type: "doc", file: "data/whitelabel/link-create", label: "Create a link" },
          { type: "doc", file: "data/whitelabel/pricing", label: "Pricing" },
          { type: "doc", file: "data/whitelabel/transactions", label: "Transactions" },
          { type: "doc", file: "data/whitelabel/customers", label: "Customers" },
          { type: "doc", file: "data/whitelabel/sms", label: "SMS" },
          { type: "doc", file: "data/whitelabel/shared-gateway-invoices", label: "Shared gateway invoices" },
          { type: "doc", file: "data/whitelabel/earnings", label: "Earnings" },
          { type: "doc", file: "data/whitelabel/referrals", label: "Referrals" },
          { type: "doc", file: "data/whitelabel/affiliates", label: "Affiliates" },
          { type: "doc", file: "data/whitelabel/cashback", label: "Cashback" },
          { type: "doc", file: "data/whitelabel/storefront/overview", label: "Storefront overview" },
          { type: "doc", file: "data/whitelabel/storefront/appearance", label: "Appearance" },
          { type: "doc", file: "data/whitelabel/storefront/domains-seo", label: "Domains & SEO" },
          { type: "doc", file: "data/whitelabel/storefront/localization", label: "Languages & currencies" },
          { type: "doc", file: "data/whitelabel/storefront/authentication", label: "Authentication" },
          { type: "doc", file: "data/whitelabel/storefront/payments", label: "Payments" },
          { type: "doc", file: "data/whitelabel/storefront/pricing-settings", label: "Manage pricing" },
          { type: "doc", file: "data/whitelabel/storefront/promotions", label: "Promotions" },
          { type: "doc", file: "data/whitelabel/storefront/referrals-settings", label: "Referrals settings" },
          { type: "doc", file: "data/whitelabel/storefront/affiliate-settings", label: "Affiliate settings" },
          { type: "doc", file: "data/whitelabel/storefront/cashback-settings", label: "Cashback settings" },
          { type: "doc", file: "data/whitelabel/storefront/legal", label: "Legal pages" },
          { type: "doc", file: "data/whitelabel/storefront/support", label: "Support" },
          { type: "doc", file: "data/whitelabel/storefront/advanced", label: "Advanced" },
        ],
      },
      {
        type: "category",
        label: "Bappy",
        link: {
          type: "doc",
          file: "data/bappy/overview",
        },
        items: [
          { type: "doc", file: "data/bappy/overview", label: "Overview" },
          { type: "doc", file: "data/bappy/dashboard", label: "Dashboard" },
          { type: "doc", file: "data/bappy/links", label: "Links" },
          { type: "doc", file: "data/bappy/link-create", label: "Create a link" },
          { type: "doc", file: "data/bappy/link-detail", label: "Link detail" },
          { type: "doc", file: "data/bappy/plans", label: "Plans" },
          { type: "doc", file: "data/bappy/plan-detail", label: "Plan detail" },
          { type: "doc", file: "data/bappy/reports", label: "Reports" },
          { type: "doc", file: "data/bappy/reports-network", label: "Network snapshots" },
          { type: "doc", file: "data/bappy/transactions", label: "Transactions" },
          { type: "doc", file: "data/bappy/sms", label: "SMS" },
          { type: "doc", file: "data/bappy/notifications", label: "Notifications" },
          { type: "doc", file: "data/bappy/coverage", label: "Coverage" },
          { type: "doc", file: "data/bappy/integrations", label: "Integrations" },
        ],
      },
      {
        type: "category",
        label: "Telkor",
        link: {
          type: "doc",
          file: "data/telkor/overview",
        },
        items: [
          { type: "doc", file: "data/telkor/overview", label: "Overview" },
          { type: "doc", file: "data/telkor/dashboard", label: "Dashboard" },
          { type: "doc", file: "data/telkor/links", label: "Links" },
          { type: "doc", file: "data/telkor/link-create", label: "Create a link" },
          { type: "doc", file: "data/telkor/link-detail", label: "Link detail" },
          { type: "doc", file: "data/telkor/sims", label: "SIMs" },
          { type: "doc", file: "data/telkor/sim-detail", label: "SIM detail" },
          { type: "doc", file: "data/telkor/plans", label: "Plans" },
          { type: "doc", file: "data/telkor/plan-create", label: "Create a plan" },
          { type: "doc", file: "data/telkor/plan-detail", label: "Plan detail" },
          { type: "doc", file: "data/telkor/coverages", label: "Coverages" },
          { type: "doc", file: "data/telkor/coverage-detail", label: "Coverage detail" },
          { type: "doc", file: "data/telkor/tasks", label: "Tasks" },
          { type: "doc", file: "data/telkor/task-detail", label: "Task detail" },
          { type: "doc", file: "data/telkor/statistics", label: "Statistics" },
        ],
      },
      {
        type: "category",
        label: "Physical SIMs",
        link: {
          type: "doc",
          file: "data/physical-sims/overview",
        },
        items: [
          { type: "doc", file: "data/physical-sims/overview", label: "Overview" },
          { type: "doc", file: "data/physical-sims/blank-sims", label: "Blank SIMs" },
          { type: "doc", file: "data/physical-sims/custom-sims", label: "Custom SIMs" },
        ],
      },
    ],
  },
  {
    type: "category",
    label: "Voice",
    link: {
      type: "doc",
      file: "voice/overview",
    },
    items: [
      { type: "doc", file: "voice/overview", label: "Overview" },
      { type: "doc", file: "voice/phone-numbers", label: "Phone numbers" },
      {
        type: "category",
        label: "OmaxPhone",
        link: {
          type: "doc",
          file: "voice/omaxphone/overview",
        },
        items: [
          { type: "doc", file: "voice/omaxphone/overview", label: "Overview" },
          { type: "doc", file: "voice/omaxphone/numbers", label: "Phone numbers" },
          { type: "doc", file: "voice/omaxphone/end-users", label: "End users" },
          { type: "doc", file: "voice/omaxphone/retail-prices", label: "Retail prices" },
        ],
      },
      { type: "doc", file: "voice/sip-trunks-destinations", label: "SIP trunks & destinations" },
    ],
  },
  {
    type: "category",
    label: "Help",
    link: {
      type: "doc",
      file: "help/faq",
    },
    items: [
      { type: "doc", file: "api-access/overview", label: "API keys" },
      { type: "doc", file: "api-access/credentials", label: "View credentials" },
      { type: "doc", file: "api-access/rotate-secret", label: "Rotate secret" },
      { type: "doc", file: "api-access/access-and-errors", label: "Access & errors" },
      { type: "doc", file: "help/access-roles", label: "Access & roles" },
      { type: "doc", file: "help/troubleshooting", label: "Troubleshooting" },
      { type: "doc", file: "help/faq", label: "FAQ" },
    ],
  },
  {
    type: "link",
    label: "API Documentation",
    to: "https://developer.omaxtelecom.com",
  },
];
